export const AppBackgroundShape = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 721.35 721.35">
      <rect width="721.35" height="721.35" fill="rgb(220,220,220)" opacity="1" rx="161.79" ry="161.79" />
    </svg>
  )
}